import { Link } from 'react-router-dom';
import { mainSiteUrl } from '@/mocks/categories';

export default function Hero() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden pt-16">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20minimalist%20abstract%20background%20with%20warm%20cream%20and%20beige%20gradient%20tones%2C%20subtle%20organic%20shapes%20and%20curves%2C%20clean%20aesthetic%20with%20gentle%20texture%2C%20light%20airy%20atmosphere%2C%20product%20display%20backdrop%20style%2C%20no%20text%2C%20no%20sharp%20elements%2C%20soft%20diffused%20lighting%2C%20elegant%20modern%20composition&width=1600&height=900&seq=hero-bg-2026-v1&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-background-50/90"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 py-20 md:py-28 text-center">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-extrabold text-white leading-tight mb-6">
          VigorBuy Spreadsheet Solutions<br className="hidden md:block" /> For Smarter Data Management
        </h1>
        <p className="text-base md:text-lg text-white/90 max-w-2xl mx-auto mb-10 leading-relaxed">
          Explore powerful spreadsheet guides, templates, comparisons and productivity strategies designed to help businesses organize data, improve workflows and make better decisions.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/vigorbuy-spreadsheet-complete-guide"
            className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-primary-500 text-white text-base font-semibold hover:bg-primary-600 transition-all duration-200 shadow-lg shadow-primary-500/30 whitespace-nowrap cursor-pointer"
          >
            Explore Complete Guide
          </Link>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-white/95 text-foreground-900 text-base font-semibold hover:bg-white transition-all duration-200 shadow-lg shadow-black/10 whitespace-nowrap cursor-pointer"
          >
            VigorBuy Spreadsheet
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6 mt-10">
          <div className="flex items-center gap-2 text-white/80 text-sm">
            <i className="ri-checkbox-circle-fill text-accent-400 text-lg w-5 h-5 flex items-center justify-center"></i>
            <span>Data Management Resources</span>
          </div>
          <div className="flex items-center gap-2 text-white/80 text-sm">
            <i className="ri-checkbox-circle-fill text-accent-400 text-lg w-5 h-5 flex items-center justify-center"></i>
            <span>Business Spreadsheet Guides</span>
          </div>
          <div className="flex items-center gap-2 text-white/80 text-sm">
            <i className="ri-checkbox-circle-fill text-accent-400 text-lg w-5 h-5 flex items-center justify-center"></i>
            <span>Security Focused</span>
          </div>
          <div className="flex items-center gap-2 text-white/80 text-sm">
            <i className="ri-checkbox-circle-fill text-accent-400 text-lg w-5 h-5 flex items-center justify-center"></i>
            <span>Updated Knowledge Base</span>
          </div>
        </div>
      </div>
    </section>
  );
}